<template>
  <div class="archive-app">
    <router-view/>
  </div>

</template>

<style>

@font-face {
     font-family:'TitilliumWeb';
     font-display: swap;
     src:
          url('@/assets/fonts/TitilliumWeb-Regular.woff2') format('woff2');
          unicode-range: U+0041-005A, U+0061-007A, U+0030-0039;
     }

@font-face {
	font-family: 'Pretendard Variable';
	font-weight: 45 920;
	font-style: normal;
	font-display: swap;
	src: url('@/assets/fonts/PretendardVariable.woff2') format('woff2-variations');

}

*{font-family: "TitilliumWeb", "Pretendard Variable", sans-serif !important}

#app,
.archive-app {
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
}

/* Keep long archive pages in normal flow; auto footer margin fills short pages. */
.archive-app > * {
  flex-shrink: 0;
}

html,
body {

  height: 100%;
  scroll-padding-top: calc(var(--header-height) + 16px);
  margin: 0;
  -ms-overflow-style: none;
  background-color: var(--archive-background);
}

::-webkit-scrollbar {
  display: none;
}

:root{
  --header-height: 100px;
  --page-gutter: clamp(20px, 4vw, 96px);
  --page-max: 1130px;
  --page-width: min(var(--page-max), calc(100% - var(--page-gutter) - var(--page-gutter)));
  --section-space: clamp(40px, 6vw, 80px);
  --archive-background: #f5f6f7;
  --swiper-theme-color: #969696 !important;
}

@media (max-width: 899px) {
  :root { --header-height: 64px; }
  html, body { touch-action: pan-x pan-y; }
  .site-header:has(.header-hidden) + .runway-page .collection-tabs { top: 0; }
}

a {
  text-decoration: none;

}
</style>
